import styled from 'styled-components'

export const StyledButton = styled.div`
  padding: 0.2rem 0.7rem;
  align-items: center;
  height: 20px;
  height: auto;
  cursor: pointer;
  display: none;

  @media screen and (max-width: 600px){
    display: flex;
  }

  &:hover span {
    text-decoration: underline;
  }
`
export const Text = styled.span`
  color: ${props => props.theme.DEFAULT_TEXT};
  font-size: 0.8rem;
  line-height: 1rem;
  margin-left: 0.8rem;
  
  @media all and (max-width: 600px){
    display: none;
  }
`
export const Icon = styled.span`
  background-color: #F7F7FC;
  height: auto;
  display: flex;
  justify-items: center;
  padding: 10px;
  border-radius: 0.4rem;
}
`
